// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UploadedItem } from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type XOrderUploadState = {
    showConflicts: boolean;
    checkInventory: boolean;
    conflictsGroups: ConflictGroup[];
};

export interface ConflictGroup {
    index: number;
    key: string;
    products: ProductDto[];
    item: UploadedItem | null;
}
const initialState: XOrderUploadState = { 
    showConflicts: false,
    checkInventory: false,
    conflictsGroups: []
 };

const xOrderUpload = createTypedReducerWithImmer(initialState, {
    "xOrderUpload/SetConflictsGroups": (
        draft: Draft<XOrderUploadState>,
        action: {conflictsGroups: ConflictGroup[], showConflicts?: boolean, checkInventory?: boolean },
    ) => {
        draft.conflictsGroups = action.conflictsGroups;
        draft.showConflicts = action.showConflicts || false;
        draft.checkInventory = action.checkInventory || false;
    },
    "xOrderUpload/SetShowConflicts": (
        draft: Draft<XOrderUploadState>,
        action: { showConflicts: boolean },
    ) => {
        draft.showConflicts = action.showConflicts;
    },
    "xOrderUpload/CleanupConflictsData": (draft: Draft<XOrderUploadState>) => {
        draft.showConflicts = false;
        draft.checkInventory = false;
        draft.conflictsGroups = [];
    },
});

type xOrderUploadReducers = {
    xOrderUpload: typeof xOrderUpload;
} & typeof reducers;

(reducers as xOrderUploadReducers).xOrderUpload = xOrderUpload;